import menu from './menu'

// Array of sections
export default [...menu]
